import { FormControl } from "@angular/forms";

export class PnInputControlConfiguration {


    constructor(public Label : string, public Type : string, public Id : string, public Control?: FormControl,public ControlName?: string) {}
    public static create = (label : string, type : string, id : string) => new PnInputControlConfiguration(label,type,id);

    setControl(value : FormControl) : PnInputControlConfiguration
    {
        this.Control = value;
        return this;
    }

    setControlName(value : string) : PnInputControlConfiguration
    {

        this.ControlName = value;
        return this;

    }


}
